import { render, staticRenderFns } from "./evaluacion-coordinadoracademico.vue?vue&type=template&id=239dbff5"
import script from "./evaluacion-coordinadoracademico.vue?vue&type=script&lang=js"
export * from "./evaluacion-coordinadoracademico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports